export enum DATA_QA {
  ROOT = 'call-times-setting-modal',
  TIME_RANGE_START = 'call-times-setting-modal__time-range-start',
  TIME_RANGE_END = 'call-times-setting-modal__time-range-end',
  REMOVE_TIME_RANGE_BUTTON = 'call-times-setting-modal__remove-time-range-button',
  ADD_HOURS_BUTTON = 'call-times-setting-modal__add-hours-button',
  APPLY_TO_DAY_CHECKBOX = 'call-times-setting-modal__apply-to-day-checkbox',
  ERROR_MESSAGE = 'dt-validation-messages',
  SAVE_BUTTON = 'call-times-setting-modal__save-button',
  CANCEL_BUTTON = 'call-times-setting-modal__cancel-button',
}
